// extracted by mini-css-extract-plugin
module.exports = {"decision":"yesNo_decision__16YfJ"};